import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { VimeoBlockAttsInterface } from '~/types/AppData/Blocks/VimeoBlockInterface';
import Embed from '~/components/Shared/Embeds/Embed';

export default component$(({ html }: VimeoBlockAttsInterface): JSX.Element => {
  return <Embed embed={html} type='vimeo' />;
});
